<app-loading class="full-width-height" [type]="'download'" *ngIf="!showPage"></app-loading>
<ng-container *ngIf="showPage">
    <ion-header>
        <ion-toolbar color="white">
            <ion-buttons slot="start">
                <ion-button (click)="goBack()">
                    <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
                </ion-button>
            </ion-buttons>
            <ion-title>
                <app-offline-indicator></app-offline-indicator>
                {{ 'APP_DOWNLOAD.title' | translate }}
            </ion-title>
        </ion-toolbar>
        <!-- <ion-toolbar class="ion-no-padding" color="white">
            
        </ion-toolbar> -->
    </ion-header>
    <ion-content>
        <div class="content-div">
            <div class="background-img">
                <div class="ion-padding vertical-center">
                    <div class="font-20 line-150 font-bold ion-text-center ion-padding-top">
                        {{ 'APP_DOWNLOAD.intro' | translate }}
                    </div>
                    <div class="font-14 ion-text-center">
                        {{ 'APP_DOWNLOAD.msg' | translate }}
                    </div>
                </div>
            </div>
            <!-- <ion-item class="store-item full-width ion-margin-top" lines="none" (click)="openWebVersion()">
                <ion-img class="store-logo" src="./assets/wedding/img/app/browser.png" slot="start"></ion-img>
                <ion-label class="font-14 font-bold" slot="start">{{ 'APP_DOWNLOAD.web' | translate }}</ion-label>
                <ion-note slot="end">
                    <ion-button class="download-btn" fill="outline" shape="round">
                        {{ 'BTN.go' | translate }}
                    </ion-button>
                </ion-note>
            </ion-item> -->
            <div class="full-width ion-padding">
                <ion-item class="store-item full-width" lines="none" (click)="openAppStore()">
                    <ion-img class="store-logo" src="./assets/wedding/img/app/appstore.webp" slot="start"></ion-img>
                    <ion-label class="font-14 font-bold" slot="start">{{ 'STORE.appstore' | translate }}</ion-label>
                    <ion-note slot="end">
                        <ion-button class="download-btn" fill="outline" shape="round">
                            {{ 'BTN.download' | translate }}
                        </ion-button>
                    </ion-note>
                </ion-item>
    
                <ng-container *ngIf="!iosApp">
                    <ion-item class="store-item full-width" lines="none" (click)="openPlayStore()">
                        <ion-img class="store-logo" src="./assets/wedding/img/app/playstore.webp" slot="start"></ion-img>
                        <ion-label class="font-14 font-bold" slot="start">{{ 'STORE.playstore' | translate }}</ion-label>
                        <ion-note slot="end">
                            <ion-button class="download-btn" fill="outline" shape="round">
                                {{ 'BTN.download' | translate }}
                            </ion-button>
                        </ion-note>
                    </ion-item>
    
                    <ion-item class="full-width" lines="none" (click)="openAppGallery()">
                        <ion-img class="store-logo" src="./assets/wedding/img/app/appgallery.webp" slot="start"></ion-img>
                        <ion-label class="font-14 font-bold" slot="start">{{ 'STORE.appgallery' | translate }}</ion-label>
                        <ion-note slot="end">
                            <ion-button class="download-btn" fill="outline" shape="round">
                                {{ 'BTN.download' | translate }}
                            </ion-button>
                        </ion-note>
                    </ion-item>
                </ng-container>
            </div>
            
            <!-- <div class="ion-text-center ion-margin">
                <ion-text class="font-20 font-med">{{ 'APP_DOWNLOAD.intro' | translate }}</ion-text>
            </div>
            <div class="ion-text-center ion-margin">
                <ion-text class="font-12">{{ 'APP_DOWNLOAD.msg' | translate }}</ion-text>
            </div>
            
            <div class="ion-margin ion-padding">
                <div (click)="openWebVersion()">
                    <div>
                        <ion-card class="background-transparent ion-no-margin" button>
                            <ion-img class="platform-img center" src="./assets/wedding/img/app/browser.png"></ion-img>
                        </ion-card>
                    </div>
                    <div class="ion-text-center">
                        <ion-text class="font-16 font-med">{{ 'APP_DOWNLOAD.web' | translate }}</ion-text>
                    </div>
                </div>
            </div>
            
            <div class="ion-margin">
                <div (click)="goStore()">
                    <div>
                        <ion-card class="background-transparent ion-no-margin" button>
                            <ion-img class="platform-img center" src="./assets/wedding/img/app/mobile.png"></ion-img>
                        </ion-card>
                    </div>
                    <div class="ion-text-center">
                        <ion-text class="font-16 font-med">{{ 'APP_DOWNLOAD.mobile' | translate }}</ion-text>
                    </div>
                </div>
                <ng-container *ngIf="!iosApp">
                    <div class="ion-margin">
                        <ion-card class="background-transparent ion-no-margin" (click)="openAppStore()" button>
                            <ion-img class="store-img center" src="./assets/wedding/img/store/appstore.png"></ion-img>
                        </ion-card>
                    </div>
                    <div class="ion-margin">
                        <ion-card class="background-transparent ion-no-margin" (click)="openPlayStore()" button>
                            <ion-img class="store-img center" src="./assets/wedding/img/store/playstore.png"></ion-img>
                        </ion-card>
                    </div>
                    <div class="ion-margin">
                        <ion-card class="background-transparent ion-no-margin" (click)="openAppGallery()" button>
                            <ion-img class="store-img center" src="./assets/wedding/img/store/appgallery.png"></ion-img>
                        </ion-card>
                    </div>
                </ng-container>
            </div> -->
        </div>
    </ion-content>
    <ion-footer>
        <ion-toolbar color="secondary">
            <div class="content-div">
                <ion-grid class="ion-padding-bottom">
                    <ion-row class="ion-align-items-center">
                        <ion-col class="ion-align-self-center ion-text-center ion-text-wrap ion-padding-top" size="6">
                            <ion-text class="font-14">
                                {{ 'APP_DOWNLOAD.sync' | translate }}
                            </ion-text></ion-col>
                        <ion-col class="ion-align-self-center" size="6">
                            <ion-img class="sync-img center" src="./assets/wedding/img/app/sync.webp"></ion-img>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </ion-toolbar>
    </ion-footer>
</ng-container>